import React, { Fragment } from "react";
import { Col, Form, Cascader } from 'antd';
import { useCommonStore } from '@/store/useCommonStore';

const AreaSelect = (props) => {
  const { value, onChange } = props;
  const areatree=useCommonStore.use.areatree();
  return (
    <Cascader
      fieldNames={{ label: 'Name', value: 'Id', children: 'children' }}
      options={areatree}
      placeholder={"请选择区域..."}
      defaultValue={value}
      onChange={onChange}
    />
  );
}

export default AreaSelect